import productDao from '../productDao';

export default {
  initSku: (skuType, platformData) => {
    const initialSku = {
      skuType,
      skuNo: '',
      gtin: '',
      skuName: platformData? platformData.platformProductName: '',
      image: '',
      imageUrl: '',
      shopUrl: '',
      platform: platformData? platformData.platform: '',
      platformPermalink: platformData? platformData.platformPermalink: '',
      platformProductId: platformData? platformData.platformProductId: '',
      enabled: true,
    };
    switch (skuType) {
      case 'BLUSH':
        return {
          ...initialSku,
          color: '#fe6161',
          patternGuid: 'patten_blush_01',
          colorIntensity: 70,
        };
      case 'EYELINER':
        return {
          ...initialSku,
          color: '#5e4040',
          patternGuid: 'patten_eyeline_160108_CNY_2',
          colorIntensity: 100,
        };
      case 'FOUNDATION':
        return {
          ...initialSku,
          color: '#eac9a4',
          patternGuid: '',
          colorIntensity: 50,
        };
      case 'EYELASHES':
      case 'MASCARA':
      default:
        return {
          ...initialSku,
          color: '#000000',
          patternGuid: 'eyelash_pattern_180213_SherlockGnomes_02',
          colorIntensity: 50,
        };
    }
  },
  fromDb: v => ({
    id: v.id ? v.id : v.skuId,
    skuType: v.skuType,
    skuNo: v.skuNo,
    gtin: v.gtin,
    skuName: v.i18n && v.i18n.enu && v.i18n.enu.skuName,
    color:
      v.colors && !!v.colors.length && v.colors[0] && v.colors[0].colorCode,
    patternGuid: v.patterns && !!v.patterns.length && v.patterns[0].patternGuid,
    colorIntensity:
      v.patterns && !!v.patterns.length && v.patterns[0].colorIntensities,
    imageUrl: v.imageUrl,
    createdTime: v.createdTime,
    lastModified: v.lastModified,
    skuStatus: v.skuStatus,
    enabled: v.skuStatus === 'ENABLED',
    productId: v.productId,
    productNo: v.productNo,
    productName: v.productName,
    shopUrl: v.shopUrl,
    platform: v.platform? v.platform: '',
    platformPermalink: v.platformPermalink,
    platformProductId: v.platformProductId? v.platformProductId: '',
  }),
  toDb: v => ({
    sku: {
      id: v.id ? v.id : v.skuId,
      skuType: v.skuType,
      skuNo: v.skuNo,
      skuStatus: v.skuStatus,
      gtin: v.gtin,
      i18n: {
        enu: {
          skuName: v.skuName,
        },
      },
      colors: [
        {
          colorCode: v.color,
        },
      ],
      patterns: [
        {
          patternIndex: 0,
          patternGuid: v.patternGuid,
          colorIndexes: '0',
          colorIntensities: v.colorIntensity,
        },
      ],
      image: v.image,
      imageUrl: v.imageUrl,
      productId: v.productId,
      productNo: v.productNo,
      productName: v.productName,
      shopUrl: v.shopUrl,
      platform: v.platform,
      platformPermalink: v.platformPermalink,
      platformProductId: v.platformProductId,
    },
    enabled: v.enabled,
  }),
};
